<template>
    <div>
       This is the Home page
    </div>
</template>